import { EasyPlanAssests } from './types/easy-plan-asset.types';
import leftArrow from './assets/left-arrow.svg';
import attentionIcon from './assets/attention-icon.svg';
import crossIcon from './assets/cross.svg';
import perksIcon from './assets/perks.svg';
import aboutIcon from './assets/about.svg';
import topImageWelcomeIcon from './assets/welcome.svg';
import topImageCostIcon from './assets/cost.svg';
import leftArrowDisabledIcon from './assets/left-arrow-disabled-icon.svg';
import rightArrowIcon from './assets/right-arrow-icon.svg';
import exitWarning from './assets/exit-warning.svg';
import rightArrowDisabledIcon from './assets/right-arrow-disabled.svg';
import placeHolderImg from './assets/placeholder.png';

export const EASY_PLAN_ASSETS: EasyPlanAssests = {
  LEFT_ARROW_DISABLED_ICON: leftArrowDisabledIcon,
  LEFT_ARROW: leftArrow,
  RIGHT_ARROW_ICON: rightArrowIcon,
  RIGHT_ARROW_DISABLED_ICON: rightArrowDisabledIcon,
  ATTENTION_ICON: attentionIcon,
  CROSS_ICON: crossIcon,
  PERKS_ICON: perksIcon,
  ABOUT_ICON: aboutIcon,
  TOP_IMAGE_WELCOME_ICON: topImageWelcomeIcon,
  TOP_IMAGE_COST_ICON: topImageCostIcon,
  EXIT_WARNING: exitWarning,
  PLACEHOLDER_IMG: placeHolderImg,
};
